import React, { useContext, useEffect } from 'react';
import { Row, Col, Button, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { PaymentContext } from '../../Context/PaymentContext';
import * as Config from '../../../Config';

const { Text } = Typography;

const PricingCard = () => {
  const { items, getModels, initiatePayment, shouldLoad } = useContext(
    PaymentContext
  );

  useEffect(() => {
    getModels();
  }, []);

  return (
    <div>
      {/* Banner */}
      <Row
        align='middle'
        justify='center'
        style={{
          color: '#121212',
          padding: '2rem',
        }}
      >
        {items.map((model) => {
          return (
            <Col
              key={model.uid}
              xs={24}
              md={7}
              style={{
                margin: '0.5rem',
                padding: '2rem',
                borderRadius: '8px',
                backgroundColor: '#fff',
                borderTop: model.showPopular ? '4px solid #f46f7c' : '',
              }}
            >
              <Row>
                <Col xs={12}>{model.label}</Col>
                <Col xs={12} align='right'>
                  {model.showPopular ? (
                    <Button shape='round' type='danger' size='small'>
                      Popular
                    </Button>
                  ) : null}
                </Col>
              </Row>
              <Col xs={24} style={{ paddingTop: '1.5rem' }}>
                <Text style={{ fontSize: '1.5rem' }} strong>
                  {model.currency}
                </Text>
                <Text style={{ fontSize: '3rem' }} strong>
                  {model.price.monthly.amount}
                </Text>
                <Text style={{ fontSize: '1rem' }} strong>
                  /month
                </Text>
              </Col>
              <Col xs={24} style={{ padding: '0.5rem 0' }}>
                <Text>{model.description}</Text>
              </Col>
              {model.features.map((feature) => {
                return (
                  <Col
                    key={feature.description}
                    xs={24}
                    style={{ padding: '0.5rem 0', fontSize: '1rem' }}
                  >
                    <CheckOutlined />{' '}
                    <Text delete={!feature.available}>
                      {feature.description}
                    </Text>
                  </Col>
                );
              })}
              <Col xs={24} align='center' style={{ padding: '2rem 0' }}>
                <Button
                  shape='round'
                  type='primary'
                  size='large'
                  onClick={() => initiatePayment(model.uid)}
                  loading={shouldLoad}
                >
                  Buy Subscription
                </Button>
              </Col>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default PricingCard;
